import Vue from 'vue';
import Component from 'vue-class-component';
import HomeCover from 'assets/graphql/queries/HomeCover.graphql';
import { useAccountStore } from 'stores/account';

@Component({
  apollo: {
    homeCover: {
      query: HomeCover,
      update(data) {
        this.desktopMedia = data.home_cover.images;
        this.mobileMedia = data.home_cover.mobile_images;
      },
    },
  },
})
export default class HomeSliderComponent extends Vue {
  imgShowing = 0;
  swipePositionStart = {
    x: 0,
    y: 0,
  };
  imageInterval = null;
  desktopMedia = [];
  mobileMedia = [];
  slideTransitionDelay = 5000;
  screenWidth = this.$screen.width;

  get media() {
    return this.$screen.width >= 768 ? this.desktopMedia : this.mobileMedia;
  }

  created() {
    this.imageInterval = setInterval(this.nextImage, this.slideTransitionDelay);
  }

  resetTimer() {
    clearInterval(this.imageInterval);
    this.imageInterval = setInterval(this.nextImage, this.slideTransitionDelay);
  }

  hoverSliderItem() {
    clearInterval(this.imageInterval);
  }

  get currentImage() {
    return this.media[this.imgShowing];
  }

  prevImage() {
    this.resetTimer();
    this.imgShowing =
      this.imgShowing !== 0 ? this.imgShowing - 1 : this.media.length - 1;
  }

  nextImage() {
    this.resetTimer();
    this.imgShowing =
      this.imgShowing !== this.media.length - 1 ? this.imgShowing + 1 : 0;
  }

  handleStart(e) {
    this.swipePositionStart.x = e.changedTouches[0].screenX;
    this.swipePositionStart.y = e.changedTouches[0].screenY;
  }

  handleEnd(e) {
    if (this.mobileMedia.length > 1) {
      const swipeXDiff =
        this.swipePositionStart.x - e.changedTouches[0].screenX;
      const swipeYDiff =
        this.swipePositionStart.y - e.changedTouches[0].screenY;

      if (Math.abs(swipeXDiff) > Math.abs(swipeYDiff)) {
        if (swipeXDiff > 0) {
          this.nextImage();
        } else {
          this.prevImage();
        }
      }
    }
  }

  get isUserPlus() {
    const account = useAccountStore();
    return !!account.userData?.is_bigbox_plus;
  }

  redirectFromCover() {
    const url = this.currentImage.url.startsWith('www.')
      ? `https://${this.currentImage.url}`
      : this.currentImage.url;
    window.location.href = url;
  }
}
